import { render } from "./variant-carousel.vue?vue&type=template&id=ac4e6fe2"
import script from "./variant-carousel.vue?vue&type=script&lang=js"
export * from "./variant-carousel.vue?vue&type=script&lang=js"

import "./variant-carousel.vue?vue&type=style&index=0&id=ac4e6fe2&lang=scss"

import exportComponent from "/__w/dryrobe.com-website/dryrobe.com-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__